<script setup lang="ts" name="SailingScheduleCardFooter">
import BaseButton from '~/components/BaseButton.vue';
import Icon from '~/components/Icon.vue';

const { isOpen } = defineProps<{
  isOpen: boolean;
}>();
</script>

<template>
  <div
    class="flex items-center justify-between border-t border-charcoal-2 py-2 pr-4 sm:hidden"
  >
    <BaseButton variant="btn-tertiary">
      {{ isOpen ? 'close schedule details' : 'see schedule details' }}
    </BaseButton>

    <Icon
      icon="mdi:chevron-right"
      class="text-primary-6"
      :class="{
        '-rotate-90': isOpen,
        'rotate-90': !isOpen,
      }"
    />
  </div>
</template>
